import { add } from '../../customer-subscriptions/services/CustomerSubscriptionsService';

const statuses = ['Active', 'Inactive', 'Pending', 'Cancelled'];

const generateSubscriptionData = (customerId?: string | null) => {
  const status = statuses[Math.floor(Math.random() * statuses.length)];
  
  return {
    customerId: customerId || `customer-${Math.random().toString(36).substr(2, 9)}`,
    status,
    items: [
      {
        priceId: `price-${Math.random().toString(36).substr(2, 9)}`,
        quantity: Math.floor(Math.random() * 5) + 1
      }
    ]
  };
};

export const generateTestCustomerSubscriptions = async (count: number, customerId?: string | null) => {
  const subscriptions = [];
  
  for (let i = 0; i < count; i++) {
    const subscriptionData = generateSubscriptionData(customerId);
    const result = await add(subscriptionData);
    if (result) {
      subscriptions.push(result);
    }
  }
  
  return subscriptions;
};